/** Contract marker only; no React component implementation is exported during P0-006. */
export const UI_CONTRACT_V1 = Object.freeze({
    audioBusIds: Object.freeze(["master", "music", "ambience", "sfx", "ui"]),
    defaultAudioLevelsPercent: Object.freeze({
        ambience: 65,
        master: 80,
        music: 55,
        sfx: 75,
        ui: 70,
    }),
    controlSchemeChoicesZhCn: Object.freeze([
        Object.freeze({ id: "auto", label: "自动选择（推荐）" }),
        Object.freeze({ id: "keyboard_mouse", label: "键盘和鼠标" }),
        Object.freeze({ id: "touch", label: "触屏" }),
    ]),
    controlSchemeCopyZhCn: Object.freeze({
        detail: "以后可以在“菜单 → 操作方式”中更改。",
        unsupported: "当前设备不支持这种操作方式。",
        current: Object.freeze({
            auto: "当前：自动选择",
            keyboard_mouse: "当前：键盘和鼠标",
            touch: "当前：触屏",
        }),
        switched: Object.freeze({
            auto: "操作方式已切换为自动选择。",
            keyboard_mouse: "操作方式已切换为键盘和鼠标。",
            touch: "操作方式已切换为触屏。",
        }),
    }),
    controlSchemeAutoInputEvidence: Object.freeze({
        allowed: Object.freeze([
            "non_modifier_keydown",
            "mouse_button_pointerdown",
            "touch_pointerdown",
        ]),
        rejected: Object.freeze([
            "synthetic_event",
            "modifier_only_keydown",
            "hover",
            "mousemove",
            "pen_pointer_input",
            "user_agent_inference",
        ]),
    }),
    autoSwitchTriggerPolicy: "consume_trusted_trigger_sequence_zero_game_intent_accept_fresh_input_only_after_reset_and_activate",
    controlSchemeGestureSwitchPolicy: "defer_until_input_idle",
    controlSchemePreferenceScope: "device_local",
    controlSchemePreferenceStorage: Object.freeze({
        adapter: "indexeddb_versioned_device_prefs_v1",
        accountSync: false,
        corruptionFallback: "unselected_require_first_entry",
        protocolOrWorldState: false,
        unknownValueFallback: "unselected_require_first_entry",
        unknownVersionFallback: "unselected_require_first_entry",
    }),
    controlSchemeMenuRule: "menu_switch_always_available",
    controlSchemeMenuReachability: "keep_current_supported_input_active_until_successful_switch",
    controlSchemeOptionVisibilityPolicy: "all_options_visible_unsupported_disabled",
    controlSchemeCapabilityRules: Object.freeze({
        auto: "resolve_from_supported_capability_or_trusted_input",
        keyboard_mouse: "keyboard_and_fine_pointer_with_hover_required",
        touch: "touch_required",
    }),
    controlSchemeSwitchAuthorityEffect: "no_world_state_or_permission_change",
    hiddenControlLayoutInputPolicy: "keep_connected_inputs_enabled",
    designContractManifest: "packages/ui/design-contract.json",
    environmentCompactWorldCardCopyZhCn: Object.freeze({
        phase: Object.freeze({
            dawn: "日出",
            day: "白昼",
            dusk: "日落",
            night: "夜晚",
        }),
        resyncRequired: "正在同步昼夜与天气…",
        unavailable: "昼夜与天气暂不可用。",
        weather: Object.freeze({
            clear: "晴朗",
            cloudy: "多云",
            rain: "下雨",
            fog: "雾天",
        }),
    }),
    environmentFailureCopyZhCn: Object.freeze({
        corrupt: Object.freeze({
            kind: "environment-data-unavailable",
            heading: "环境数据无法读取",
            detail: "已停止显示时间和天气，以免使用损坏的数据。",
            action: Object.freeze({ id: "return-to-world-list", label: "返回世界列表", enabled: true }),
        }),
        notLoaded: Object.freeze({
            kind: "environment-not-ready",
            heading: "环境尚未准备好",
            detail: "时间和天气暂时无法显示。",
            action: Object.freeze({ id: "retry-environment", label: "重试", enabled: true }),
        }),
        resyncRequired: Object.freeze({
            kind: "environment-sync-required",
            heading: "环境状态需要同步",
            detail: "正在获取最新的时间和天气。",
            action: Object.freeze({ id: "retry-environment", label: "重试同步", enabled: true }),
        }),
        unsupported: Object.freeze({
            kind: "environment-update-required",
            heading: "需要更新游戏",
            detail: "当前版本无法读取这个世界的环境数据。",
            action: Object.freeze({ id: "update-game", label: "更新游戏", enabled: true }),
        }),
    }),
    implementationTask: "P0-022",
    originalMusicTracks: Object.freeze([
        Object.freeze({ id: "music.morning-cove.v1", titleZhCn: "晨湾" }),
        Object.freeze({ id: "music.cloud-hill.v1", titleZhCn: "云上草坡" }),
        Object.freeze({ id: "music.tidal-lanterns.v1", titleZhCn: "潮汐灯火" }),
        Object.freeze({ id: "music.starsea-home.v1", titleZhCn: "星海归途" }),
    ]),
    requiredDirection: "ltr",
    requiredLocale: "zh-CN",
    version: 1,
});
